import { useTranslation } from "react-i18next";
import React from "react";
import { QuestionProps } from "../../../../../types/course";
import { Form, Select } from "antd";

function Dropdown({ isCorrect, isIncorrect }: QuestionProps) {
  const { t } = useTranslation();
  return (
    <Form.Item
      name="dropdown"
      initialValue={1}
      rules={[{ required: true, message: t("Vui lòng chọn đáp án", "Vui lòng chọn đáp án") }]}
      className={`${isCorrect ? "select-quiz-correct" : ""} ${isIncorrect ? "select-quiz-incorrect choose-incorrect" : ""}`}
    >
      <Select
        disabled
        placeholder={t("Chọn đáp án của bạn", "Chọn đáp án của bạn")}
        options={[
          { label: t("Đáp án 01", "Đáp án 01"), value: 1 },
          { label: t("Đáp án 02", "Đáp án 02"), value: 2 },
          { label: t("Đáp án 03", "Đáp án 03"), value: 3 },
          { label: t("Đáp án 04", "Đáp án 04"), value: 4 },
        ]}
      />
    </Form.Item>
  );
}

export default Dropdown;
